// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"4":"f9bd1a2f","381":"c64c0af6"}[chunkId] + ".css";
};